import React from 'react';
import { Center } from './common.styled';
import CircularProgress from '../../../CircularProgress';

export default () => (
  <Center>
    <CircularProgress />
  </Center>
);
